import React, { useEffect, useState } from 'react';
import {
    fetchReceiptTexts,
    getReceiptInfo,
    performActionWithAdjustedFibonacciBackoff,
    ReceiptInfo,
    ReceiptInfoResource,
    ReceiptTexts,
} from '../api/receiptAPI';
import styles from './receiptPage.module.scss';
import { useNavigate, useParams } from 'react-router-dom';
import loader from '../loading-spinner.module.scss';

function ReceiptPage() {
    const { reference } = useParams();
    const [receiptTexts, setReceiptTexts] = useState<ReceiptTexts>();
    const [receiptInfo, setReceiptInfo] = useState<ReceiptInfo>();
    const navigate = useNavigate();

    useEffect(() => {
        window.scrollTo(0, 0);
        fetchReceiptTexts().then((response) => setReceiptTexts(response));
    }, []);

    useEffect(() => {
        if (!reference) return;
        const pollReceiptInfo = performActionWithAdjustedFibonacciBackoff<ReceiptInfoResource>(
            () => getReceiptInfo(reference),
            (result) => result.status === 'ok' || result.status === 'error',
            100,
            3000,
            10
        );
        pollReceiptInfo
            .then((result) => {
                if (result.status !== 'ok') {
                    navigate('/feil');
                } else {
                    setReceiptInfo(result.data);
                }
            })
            .catch(() => navigate('/feil'));
    }, [reference, navigate]);

    if (!receiptTexts) {
        return null;
    }

    const hasFamilyMembers =
        receiptInfo?.registeredFamilyMembers?.length !== undefined && receiptInfo?.registeredFamilyMembers?.length > 0;

    const descriptionText1 = hasFamilyMembers ? receiptTexts.description1Family : receiptTexts.description1;

    const descriptionText2 = hasFamilyMembers ? receiptTexts.description2Family : receiptTexts.description2;

    return (
        <div className={styles.receiptContainer}>
            <div className={styles.logo}>
                <img src={process.env.PUBLIC_URL + '/Images/Logo.svg'} alt="SkiforeningenLogo" />
            </div>
            {receiptInfo && receiptInfo.firstName ? (
                <div>
                    <h1 className={styles.header}>
                        {receiptTexts.title + ', '}
                        {receiptInfo.firstName}!
                    </h1>
                    {receiptInfo?.registeredFamilyMembers && receiptInfo.registeredFamilyMembers.length > 0 && (
                        <div className={styles.familyMembers}>
                            <div className={styles.title}>Familiemedlemmer:</div>
                            <div>
                                {receiptInfo?.registeredFamilyMembers?.map((x, index) => (
                                    <div key={index} className={styles.member}>
                                        <div> {x.fullName}</div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                    {receiptInfo?.duplicateFamilyMembers && receiptInfo.duplicateFamilyMembers.length > 0 && (
                        <div className={styles.familyMembers}>
                            <div className={styles.title}>{receiptTexts.warningDuplicatesHeader}</div>
                            <div className={styles.warningText}>{receiptTexts.warningDuplicates}</div>
                            <div>
                                {receiptInfo?.duplicateFamilyMembers?.map((x, index) => (
                                    <div key={index} className={styles.member}>
                                        <div> {x.fullName}</div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                    {receiptInfo?.failedFamilyMembers && receiptInfo.failedFamilyMembers.length > 0 && (
                        <div className={styles.familyMembers}>
                            <div className={styles.title}>{receiptTexts.warningFailedHeader}</div>
                            <div className={styles.warningText}>{receiptTexts.warningFailed}</div>
                            <div>
                                {receiptInfo?.failedFamilyMembers?.map((x, index) => (
                                    <div key={index} className={styles.member}>
                                        <div> {x.fullName}</div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                    <p className={styles.description}>{descriptionText1}</p>
                    <p className={styles.description}>{descriptionText2}</p>
                    <a
                        className={styles.link}
                        href={'https://www.skiforeningen.no/medlemsskap/ditt-medlemskap/medlemsfordeler/'}
                    >
                        Se dine medlemsfordeler
                    </a>
                </div>
            ) : (
                <div>
                    <p className={styles.description}>Registrer medlemskap...</p>
                    <div className={loader.ReceiptPage}>
                        <div className={loader.loader} />
                    </div>
                </div>
            )}
            {receiptInfo && (
                <div className={styles.graphicContainer}>
                    <img
                        className={styles.bottomGraphic}
                        src={process.env.PUBLIC_URL + '/Images/BottomGraphic.svg'}
                        alt=""
                    />
                </div>
            )}
        </div>
    );
}

export default ReceiptPage;
